import React from 'react';
import { useIsB2B } from 'components/B2BComponents/useIsB2B';

interface EstimateComponentProps {
  b2b?: React.ReactNode;
  b2c?: React.ReactNode;
  'data-cy'?: string;
}

const B2BComponent = ({ b2b, b2c, 'data-cy': dataCy }: EstimateComponentProps) => {
  const isB2B = useIsB2B();
  return <div data-cy={dataCy}>{isB2B ? b2b : b2c}</div>;
};

export default B2BComponent;
